export default class User {
  id: number = 0;
  username: string = '';
  email: string = '';
  authorities: string[] =  [''];

  constructor() { }
}